import ModulePlanningLecturerModelBase from '../_generated/modelBases/module-planning-lecturer-model-base';

export default class ModulePlanningLecturerModel extends ModulePlanningLecturerModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
